import React from 'react'
import Timeline from '@mui/lab/Timeline'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineDot from '@mui/lab/TimelineDot'
import Typography from '@mui/material/Typography'
import './Timeline.css'
 

function TimelineComponent ({ title, children ,icon}) {
  return (
    <div className='timeline'>
      <Timeline className='timeline'>
        {/* item header */}
        <TimelineItem className='timeline-first-item'>
          <TimelineSeparator>
            <TimelineDot className='timeline-dot-header'>
              {icon}
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant='h6' className='timeline-header'>
              {title}
            </Typography>
          </TimelineContent>
        </TimelineItem>
        {children}
      </Timeline>
    </div>
  )
}

export default TimelineComponent
